/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { API } from "./base";
import { HireItem, PackageSlot } from "../types";

const api = new API();


/**
 * Hits the `#[Route('{uid}/products')]` in the Hire controller in TheyStay/API returning
 * a list of HireItems belonging to the provided entity.
 */
export async function getHireItems(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/hire/${entity_uid}/products`,
    });

    return res.items as HireItem[];
}


/**
 * Hits the `#[Route('package-slots-available/{package_uid}')]` in the Hire controller in TheyStay/API returning
 * a list of HireItems belonging to the provided entity.
 */
export async function getHirePackageTimesAvailable(package_uid: string, start_date: string, end_date: string, qty: number) {
    const res = await api.call({
        method: 'GET',
        endpoint: `/hire/package-slots-available/${package_uid}`,
        query: {
            start: start_date,
            end: end_date,
            qty: qty,
        }
    });

    return res as PackageSlot[];
}


/**
 * Hits the `#[Route('product/{product_uid}')]` in the HireApi controller in TheyStay/API returning
 * a single hire item.
 */
export async function getSingleHireItem(hireitem_uid: string) {
    const res = await api.call({
        method: 'GET',
        endpoint: `/hire/product/${hireitem_uid}`,
    });

    return res.product as HireItem;
}


export async function createHireBooking(form: any) {
    let {base_entity_uid} = api.config;

    const res = await api.call({
        method: 'POST',
        endpoint: `/hire/${base_entity_uid}/hire-order-create`,
        body: form
    })

    return res;
}